<template>
	<b-input-group>
		<b-form-input v-bind="$attrs" :value="value" :type="revealed ? 'text' : 'password'" @input="$emit('input', $event)"></b-form-input>
		<b-input-group-append>
			<b-button variant="outline-secondary" @click="revealed = !revealed" tabindex="-1" :title="revealed ? 'Hide' : 'Show'">
				<b-icon :icon="revealed ? 'eye-slash' : 'eye'"></b-icon>
			</b-button>
		</b-input-group-append>
	</b-input-group>
</template>

<script>
export default {
	name: 'PasswordInput',
	inheritAttrs: false,
	props: {
		value: { type: String, default: '' },
	},
	data() { return {
		revealed: false,
	}},
};
</script>
